import { getAttribute } from '@/presenters/components/search/Filters/utils/getAttribute';

import { numberFilters } from '../../utils/number-filters';
import { safeDecodeURI } from '../../utils/safe-decode-uri';

const FILTERS_MAP = ['ofertas', 'frete-gratis', 'black-friday'];

export interface ToggleFilterProps {
  routeState: Record<string, boolean>;
  href: string;
  region: string;
}

const toggleFilter = (props: ToggleFilterProps) => {
  const { routeState, href, region } = props;

  if (!routeState) {
    return href;
  }

  const newUrl = new URL(href);
  let numberFilter = numberFilters(href);

  Object.keys(routeState).forEach((key) => {
    const filter = getAttribute(region).toggle[key];
    let addFilter = true;

    if (href.includes(filter.filterName)) {
      addFilter = false;
    } else if (numberFilter === 0) {
      const filterValue = FILTERS_MAP.includes(filter.filterName)
        ? ''
        : `/${filter.filterValue}`;

      newUrl.pathname += `/${filter.filterName}${filterValue}`;
    } else if (numberFilter === 1) {
      newUrl.search = `?filter[${filter.filterName}]=${filter.filterValue}`;
    } else if (numberFilter > 1) {
      newUrl.search += `${newUrl.search ? '&' : ''}filter[${
        filter.filterName
      }]=${filter.filterValue}`;
    }

    if (addFilter) numberFilter++;
  });

  return safeDecodeURI(newUrl.toString());
};

export default toggleFilter;
